module.exports = __webpack_public_path__ + "img/history-illustration.09ebed32.png";